import React, { useEffect, useState } from "react";
import "../assets/css/style.css";
import { useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu"; // Importing Menu icon for mobile view
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch, useSelector } from "react-redux";
import { clearFilterPayload } from "../redux/actions/filterPayloadSlice";
import API from "../services/apiMiddleware";
import { setsurveyCategoryLists } from "../redux/actions/surveyCategoryLists";
import { setCommunityData } from "../redux/actions/communityDetails";
import {
  getSurveyDetailsBasedOnCategory,
  surveyExcelGeneration,
  postClearCache,
  getRoleDetails,
} from "../services/urls";
import { showAlert, successAlert } from "../components/core/errorHandling";
import { Button } from "@mui/material";
import { setRoleInfoData } from "../redux/actions/roleInfo";
import Loader from "../components/Loader";

function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = React.useState(null); // Mobile menu state
  const [categoryList, setCategoryList] = useState([]);
  const [activeId, setActiveId] = useState(1);
  const path = useLocation();
  const communityId = useSelector((state) => state.communityData.communityId);
  const roleId = useSelector((state) => state.communityData.roleId);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    surveyDetailBasedOncategory();
  }, []);

  useEffect(() => {
    if (path) {
      const categoryId = path.pathname.split("/")[2];
      const checkUserId = path.pathname.split("/")[1];
      if (categoryId) {
        updateTabSection(categoryId);
      } else {
        updateTabSection(1);
      }
      if (checkUserId === "userinfo") {
        updateTabSection(2);
      }
    }
  }, [path]);

  useEffect(() => {
    getRoleDetailsData();
  }, []);

  const surveyDetailBasedOncategory = async () => {
    const isPayload = {
      communityId,
    };
    API.post(getSurveyDetailsBasedOnCategory, isPayload)
      .then(({ data }) => {
        let categoryLists = data.data;
        const category = Object.keys(categoryLists).map((category) => {
          return {
            categoryId: category,
            categoryLabel: categoryLists[category],
          };
        });
        setCategoryList(category);
        dispatch(setsurveyCategoryLists(category));
      })
      .catch((error) => {
        console.error("Error fetching category  data:", error);
      });
  };

  // Handle opening and closing of the mobile menu
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const updateTabSection = (serviceId) => {
    setActiveId(serviceId);
  };

  const handleLogoClick = () => {
    navigate("/");
  };

  const handleOverviewClick = () => {
    navigate("/");
    dispatch(clearFilterPayload(null));
  };

  const handleUserInfoClick = () => {
    navigate("/userinfo");
    dispatch(clearFilterPayload(null));
  };

  const handleCategoryClick = (category) => {
    navigate(`/category/${category.categoryId}`);
    // dispatch(clearFilterPayload(null));
  };

  // Function to convert base 64 API into string
  const base64ToUint8Array = (string) => {
    let raw = window.atob(string);
    let rawLength = raw.length;
    let array = new Uint8Array(new ArrayBuffer(rawLength));
    for (var i = 0; i < rawLength; i += 1) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  };

  const getExcelData = () => {
    let oRequest = {
      communityId,
      roleType: ["Applicant", "GuestUser", "DS-TB", "MDR-TB"],
      languageId: 1,
      scheduledFlag: true,
      surveyId: null,
      roleId: 906,
    };
    // check if byte array empty then show message file not available
    API.post(surveyExcelGeneration, oRequest)
      .then((res) => {
        let communitylinelistExcelContent = res.data.data.fileData;
        const fileBlob = new Blob(
          [base64ToUint8Array(communitylinelistExcelContent)],
          {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }
        );

        let objectURL = URL.createObjectURL(fileBlob);
        const exportLinkElement = document.createElement("a");
        exportLinkElement.hidden = true;
        exportLinkElement.download =
          "Survey_" + new Date().toLocaleString() + ".xlsx";
        exportLinkElement.href = objectURL;
        exportLinkElement.text = "downloading...";

        document.body.appendChild(exportLinkElement);
        exportLinkElement.click();

        URL.revokeObjectURL(objectURL);
        exportLinkElement.remove();
      })
      .catch((e) => {
        console.log(e);
        showAlert();
      });
  };

  const handleLogout = () => {
    dispatch(setCommunityData(null));
    dispatch(clearFilterPayload(null));
    localStorage.removeItem("communityData");
    navigate("/login");
  };

  const handleSyncDashboard = () => {
    let oRequest = {
      communityId,
      hardReload: true,
      roleId,
    };
    setLoading(true); // show loader
    API.post(postClearCache, oRequest)
      .then(() => {
        // getAnalyticDetail();
        successAlert("Synced successfully");
      })
      .catch((error) => {
        console.error("Error fetching postClearCache api:", error);
      })
      .finally(() => {
        setLoading(false); // hide loader
      });
  };

  const getRoleDetailsData = async () => {
    let requestBody = {
      communityId,
      roleId,
    };

    API.post(getRoleDetails, requestBody)
      .then(({ data }) => {
        const getRoleDetailsData = data.data.roleSpecificFilters;
        const roleInfo = {
          districtFilter: getRoleDetailsData?.districtFilter,
          districtValue: getRoleDetailsData?.districtValue,
          healthFacilityFilter: getRoleDetailsData?.healthFacilityFilter,
          healthFacilityValue: getRoleDetailsData?.healthFacilityValue,
          questionId: getRoleDetailsData?.questionId,
        };
        dispatch(setRoleInfoData(roleInfo));
      })
      .catch((error) => {
        console.error("Error fetching user counters data:", error);
      });
  };

  return (
    <div className="header">
      {loading && (
        <div className="loader-header">
          <Loader />
        </div>
      )}
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" className="navbar">
          <Toolbar className="header-container">
            {/* Platform Name */}
            <Typography className="navheading" onClick={handleLogoClick}>
              WhatsApp Dashboard
            </Typography>

            {/* Mobile Menu Icon */}
            <Box sx={{ display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="menu"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
                className="menuIconNav"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
              >
                <MenuItem
                  onClick={() => {
                    navigate("/userinfo");
                    handleCloseNavMenu();
                  }}
                >
                  User Info
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    navigate("/");
                    handleCloseNavMenu();
                  }}
                >
                  Overview
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate("/checkup");
                    handleCloseNavMenu();
                  }}
                >
                  Checkup
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate("/sevendays");
                    handleCloseNavMenu();
                  }}
                >
                  7 Days
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate("/fourteendays");
                    handleCloseNavMenu();
                  }}
                >
                  14 Days
                </MenuItem>
              </Menu>
            </Box>

            {/* Desktop Menu Links */}
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              <div className="routingComp">
                <div
                  className={`${activeId === 2 ? "active" : ""}`}
                  onClick={handleUserInfoClick}
                >
                  User Info
                </div>
                <div
                  className={`routingComp ${activeId === 1 ? "active" : ""}`}
                  onClick={handleOverviewClick}
                >
                  Overview
                </div>
                {categoryList &&
                  categoryList.map((category) => {
                    return (
                      <div
                        className={`${
                          category.categoryId === activeId ? "active" : ""
                        }`}
                        onClick={() => handleCategoryClick(category)}
                      >
                        {category.categoryLabel}
                      </div>
                    );
                  })}
                {/* <div className="sync-data-button"></div> */}
                <Button
                  variant="outlined"
                  onClick={handleSyncDashboard}
                  className="sync-data-button"
                >
                  {loading ? "Syncing..." : "Sync Data"}
                </Button>

                <div className="download-excel" onClick={getExcelData}>
                  Download Excel
                </div>
                <div onClick={handleLogout}>Logout</div>
              </div>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
    </div>
  );
}

export default Header;
